import {Component, Input, EventEmitter, Output, inject} from '@angular/core';
import {DatePipe} from '@angular/common';
import {GroupSeriesInfoDto} from '../../dtos/groupseriesinfo.dto';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
  selector: 'app-course-card',
  imports: [DatePipe, TranslocoPipe],
  templateUrl: './course-card.component.html',
  styleUrl: './course-card.component.scss'
})
export class CourseCardComponent {
  translocoService = inject(TranslocoService);
  @Input() dto!: GroupSeriesInfoDto;
  @Output() cardClicked = new EventEmitter<void>();
  isNarrow: boolean = false;
  isSmall: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 400px)',     // mobile
      '(min-width: 401px) and (max-width: 520px)', // tablet
      '(min-width: 521px)'        // desktop
    ]).subscribe(result => {
      if (result.breakpoints['(max-width: 400px)']) {
        this.isNarrow = true;
        this.isSmall = false;
      } else if (result.breakpoints['(min-width: 401px) and (max-width: 520px)']) {
        this.isNarrow = false;
        this.isSmall = true;
      } else {
        this.isNarrow = false;
        this.isSmall = false;
      }
    });
  }

  formatDescription(value: string | undefined) {
    if (value) {
      if (this.isNarrow && value.length > 35) {
        return value.substring(0, 35) + '...';
      }
      if (this.isSmall && value.length > 80) {
        return value.substring(0, 80) + '...';
      }
      if (value.length > 100) {
        return value.substring(0, 100) + '...';
      }
    }

    return value;
  }

  getInfoLine() {
    let result = '';
    if (this.dto.weekDays) {
      let weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      this.dto.weekDays.forEach((value, index) => {
        if (index > 0) {
          result += ', ';
        }

        result += this.translocoService.translate('days.common.' + weekdays[value]);
      });
      if (this.dto.timeInfo) {
        result += ' ' + this.dto.timeInfo;
      }
    }

    result += ' ' + this.translocoService.translate('courses.withSmall') + ' ' + this.dto.therapist;
    return result;
  }

  onClick() {
    this.cardClicked.emit();
  }
}
